import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonMessages } from 'src/app/utils/validators/common.message';
import { CommonValidators } from 'src/app/utils/validators/common.validator';

@Component({
  selector: 'app-codigo-input',
  standalone: true,
  imports: [],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CodigoInputComponent),
    multi: true
  }],
  templateUrl: './codigo-input.component.html',
  styleUrl: './codigo-input.component.css'
})
export class CodigoInputComponent implements ControlValueAccessor {
  @Input() labelTitle?: string;
  @Input() isDisabled?: boolean;
  @Input() placeholder = '';
  @Input() buttonText = '';
  @Input() buttonDisabled = false;
  @Input() corBotao = '';
  @Input() corTextoBotao = '';
  @Input() Fieldpattern = "[0-9]"
  @Input() Fieldtype = 'number';
  @Input() FieldMin = 18;

  @Output() TextChanged = new EventEmitter<string>();
  @Output() buttonClick = new EventEmitter<void>();

  public errorMsg = "";
  public inputValue = '';

  constructor(private cd: ChangeDetectorRef) {
  }

  writeValue(obj: string): void {
    this.inputValue = obj || '';
  }

  registerOnChange(fn: (s: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    fn();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  private onChange = (value: string) => {
    if(value.length > 0 && (value.length < this.FieldMin || !CommonValidators.isNumericOnly(value)))
      this.errorMsg = CommonMessages.LimiteMinimoCodigoAutenticidade;
    else this.errorMsg = "";
  };

  onButtonClick() {
    this.buttonClick.emit();
  }

  public onTextChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.inputValue = value;
    this.onChange(value);
    this.TextChanged.emit(value);
  }
}
